<img class="image"
  [class]="{'image__hidden': !imageLoaded}"
  [src]="src"
  [alt]="alt"
  (load)="onImageLoad($event)">
<fm-ghost-element *ngIf="!imageLoaded"></fm-ghost-element>